import { render, staticRenderFns } from "./PriceUpdateWarning.vue?vue&type=template&id=40f3ccaf&scoped=true&"
import script from "./PriceUpdateWarning.vue?vue&type=script&lang=js&"
export * from "./PriceUpdateWarning.vue?vue&type=script&lang=js&"
import style0 from "./PriceUpdateWarning.vue?vue&type=style&index=0&id=40f3ccaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f3ccaf",
  null
  
)

export default component.exports